// extracted by mini-css-extract-plugin
export default {"bottom":"bottom___AOq9h","left_block":"left_block___qDYAn","price":"price___BFlik","right_block":"right_block____djM0","btn":"btn___vrYcb","paragraph":"paragraph___dPNto"};